export abstract class UpdateSubsidyJuridicalRequest {

    protected constructor(
        readonly id: number,
    ) {
    }
}